import { FlashList, FlashListProps } from "@shopify/flash-list";
import { useEffect, useMemo, useRef } from "react";
import { View } from "react-native";
import ListFooterComponent from "src/components/ListFooterComponent";
import { paddingLarge } from "src/styles/spacing";
import CommentInputBar from "./components/CommentInputBar";
import CommentKeyboardAvoidingWrapper from "./components/CommentKeyboardAvoidingWrapper";
import CommentsThreadHeader from "./components/CommentsThreadHeader";
import renderCommentThreadItem, {
	commentThreadKeyExtractor,
} from "./helpers/renderCommentThreadItem";
import useCommentsThreadData from "./hooks/useCommentsThreadData";
import useCommentsThreadStore from "./hooks/useCommentsThreadStore";

const CommentsThreadContent = ({ testID }: { testID?: string }) => {
	const flashListRef = useRef<FlashList<any>>(null);
	const { listData, fetchMore, loading } = useCommentsThreadData({
		listRef: flashListRef,
	});
	const safeArea = useCommentsThreadStore((state) => state.safeArea);
	const topic = useCommentsThreadStore((state) => state.topic);
	const flashListProps = useMemo<Partial<FlashListProps<any>>>(
		() => ({
			contentContainerStyle: {
				// Offsets the content to account for the safe area at the bottom
				// Would be paddingTop but the list is inverted
				paddingBottom: safeArea.bottom + paddingLarge,
			},
		}),
		[safeArea.bottom],
	);

	useEffect(() => {
		const { unsubscribe } = topic.on("onTextInputFocus", () => {
			flashListRef.current?.scrollToOffset({
				offset: 0,
				animated: true,
			});
		});
		return () => {
			unsubscribe();
		};
	}, [topic]);

	return (
		<View
			testID={testID}
			style={{
				width: "100%",
				height: "100%",
			}}
		>
			<CommentsThreadHeader />
			<CommentKeyboardAvoidingWrapper>
				<View
					style={{
						flex: 1,
					}}
				>
					<FlashList
						ref={flashListRef}
						{...flashListProps}
						data={listData}
						onEndReached={fetchMore}
						onEndReachedThreshold={0.5}
						keyboardDismissMode="on-drag"
						keyExtractor={commentThreadKeyExtractor}
						renderItem={renderCommentThreadItem}
						estimatedItemSize={46}
						inverted
						ListFooterComponent={<ListFooterComponent loading={loading} />}
					/>
				</View>
				<CommentInputBar />
			</CommentKeyboardAvoidingWrapper>
		</View>
	);
};
export default CommentsThreadContent;
